/**
 * Servicio para gestión de presencia online y heartbeat
 */
import { api } from '../config/api';

// Throttle para actividad (máximo una vez cada 5 segundos)
let lastActivityTime = 0;
const ACTIVITY_THROTTLE_MS = 5000;

const presenceService = {
  /**
   * Envía un heartbeat al servidor (solo actualiza last_heartbeat, NO cambia status)
   */
  sendHeartbeat: async () => {
    try {
      // Solo enviar si el documento está visible
      if (document.visibilityState !== 'visible') {
        return { skipped: true, reason: 'document_not_visible' };
      }

      const response = await api.post('/auth/heartbeat/');
      return response;
    } catch (error) {
      console.error('[PRESENCE SERVICE] Error enviando heartbeat:', error);
      // No lanzar error, solo loguear
      return { error: error.message };
    }
  },

  /**
   * Envía actividad al servidor (marca usuario como online)
   * Throttled para evitar demasiadas peticiones
   */
  sendActivity: async () => {
    try {
      // Solo enviar si el documento está visible
      if (document.visibilityState !== 'visible') {
        return { skipped: true, reason: 'document_not_visible' };
      }

      // Throttle: máximo una vez cada 5 segundos
      const now = Date.now();
      if (now - lastActivityTime < ACTIVITY_THROTTLE_MS) {
        return { skipped: true, reason: 'throttled' };
      }
      lastActivityTime = now;
      // Activity is handled server-side via Django signals / views
      return { skipped: true, reason: 'server_side_activity' };
    } catch (error) {
      console.error('[PRESENCE SERVICE] Error enviando actividad:', error);
      // No lanzar error, solo loguear
      return { error: error.message };
    }
  },

  /**
   * Obtiene la lista de usuarios online (status='online')
   */
  getOnlineUsers: async () => {
    try {
      const response = await api.get('/auth/online/');
      return response.online_users || [];
    } catch (error) {
      console.error('[PRESENCE SERVICE] Error obteniendo usuarios online:', error);
      return [];
    }
  },
};

export default presenceService;
